import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';

import { useI18n } from '../i18n/I18nContext';
import { coverfyLinks, consoleLinks } from '../config/domains';
import LanguageSelector from './LanguageSelector';

export default function Layout({ children }) {
  const loc = useLocation();
  const { t } = useI18n();
  const [open, setOpen] = useState(false);

  const navLink = (path, label, exact = false) => {
    const active = exact ? loc.pathname === path : loc.pathname.startsWith(path);
    return (
      <Link
        to={path}
        className={active ? 'font-semibold text-coverfy-accent' : 'text-slate-600 hover:text-coverfy-accent'}
      >
        {label}
      </Link>
    );
  };

  return (
    <div className="min-h-[100dvh] flex flex-col">
      <header className="sticky top-0 z-[60] border-b border-slate-200/80 bg-white/90 backdrop-blur-md">
        <div className="mx-auto flex max-w-6xl items-center gap-4 px-4 py-3 md:px-6">
          <Link to="/" className="text-lg font-semibold tracking-tight text-coverfy-ink">
            Coverfy
            <span className="ml-2 hidden text-[0.65rem] font-semibold uppercase tracking-widest text-slate-400 md:inline">
              {t('nav.tagline')}
            </span>
          </Link>

          <nav className="ml-auto hidden items-center gap-4 text-sm md:flex">
            {navLink('/', t('nav.home'), true)}
            {navLink('/partners', t('nav.partners'))}
            {navLink('/pricing', t('nav.pricing'))}
            <LanguageSelector />
            <Link
              to="/apply"
              className="rounded-full bg-coverfy-accent px-4 py-1.5 text-white transition active:scale-[0.98]"
            >
              {t('nav.apply')}
            </Link>
            <a
              href={consoleLinks.login}
              className="text-slate-600 hover:text-coverfy-accent"
              rel="noopener noreferrer"
            >
              {t('nav.login')}
            </a>
          </nav>

          <button
            type="button"
            aria-label="Menu"
            onClick={() => setOpen((o) => !o)}
            className="ml-auto rounded-full border border-slate-200 p-2 text-slate-600 md:hidden"
          >
            <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>

        {open && (
          <div className="border-t border-slate-200 bg-white px-4 py-3 md:hidden">
            <div className="flex flex-col gap-3 text-sm">
              {navLink('/', t('nav.home'), true)}
              {navLink('/partners', t('nav.partners'))}
              {navLink('/pricing', t('nav.pricing'))}
              {navLink('/apply', t('nav.apply'))}
              <a href={consoleLinks.login} className="text-slate-600" rel="noopener noreferrer">
                {t('nav.login')}
              </a>
              <LanguageSelector />
            </div>
          </div>
        )}
      </header>

      <main className="flex-1">{children}</main>

      <footer className="border-t border-slate-200 bg-white px-4 py-10">
        <div className="mx-auto max-w-6xl text-center">
          <p className="mx-auto max-w-3xl text-xs leading-relaxed text-slate-500">{t('footer.subtagline')}</p>
          <p className="mt-3 text-xs text-slate-400">{t('footer.tagline')}</p>
          <p className="mt-4 flex flex-wrap justify-center gap-3 text-xs">
            <Link to="/partners" className="text-coverfy-accent">
              {t('nav.partners')}
            </Link>
            <Link to="/pricing" className="text-coverfy-accent">
              {t('nav.pricing')}
            </Link>
            <Link to="/apply" className="text-coverfy-accent">
              {t('nav.apply')}
            </Link>
            <a href={coverfyLinks.home} className="text-coverfy-accent" rel="noopener noreferrer">
              {t('footer.family')}
            </a>
            <a href={consoleLinks.login} className="text-coverfy-accent" rel="noopener noreferrer">
              {t('footer.console')}
            </a>
          </p>
          <p className="mt-4 text-[0.7rem] text-slate-400">
            © {new Date().getFullYear()} Coverfy · Advisor Site · v0.1.0
          </p>
        </div>
      </footer>
    </div>
  );
}
